import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons';

const NotFoundScreen: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
            <div className="w-20 h-20 rounded-2xl bg-slate-100 flex items-center justify-center mb-6">
                <FontAwesomeIcon icon={faMapLocationDot} className="text-3xl text-slate-400" />
            </div>
            <h1 className="text-6xl font-bold text-slate-900 mb-2">404</h1>
            <p className="text-lg text-slate-500 mb-6">{t('messages.page_not_found')}</p>
            <a href="/home" className="btn-primary-tw text-sm no-underline">
                {t('menu.home')}
            </a>
        </div>
    );
};

export default NotFoundScreen;
